import qs from 'querystring';

let {search} = location;
let searchObj = search ? qs.parse(search.substr(1)) : {};
let {dev} = searchObj;

const HOST = location.hostname;

let urlHost;

if (/51ping/.test(HOST)) {
    urlHost = '//m.51ping.com';
} else if (/dianping/.test(HOST)) {
    urlHost = '//m.dianping.com';
} else if (/test/.test(HOST)) {
    urlHost = '//test.i.meituan.com';
} else if (/meituan/.test(HOST)) {
    urlHost = '//i.meituan.com';
} else {
    urlHost = '//m.51ping.com';
}

if (dev === 'dp_data') {
    urlHost = '//m.dianping.com';
} else if (dev === 'mt_data') {
    urlHost = '//i.meituan.com';
}

export {urlHost, searchObj};


// WEBPACK FOOTER //
// ./src/tools/gethost.js